import { Center, Text } from '@chakra-ui/react';

interface EmptyStateProps {
  search: string;
}

export const EmptyState = ({ search }: EmptyStateProps) => (
  <Center flexDirection="column" height="100%">
    <Text
      fontSize="xl"
      fontWeight={500}
      textAlign="center"
      maxWidth="600px"
      wordBreak="break-word"
      data-testid="empty-list-title"
    >
      No results found for &quot;{search}&quot;
    </Text>
    <Text
      fontSize="md"
      color="textSubdued"
      textAlign="center"
      data-testid="empty-list-message"
    >
      Please check your spelling or try a different keyword.
    </Text>
  </Center>
);
